import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import TwoWayInputArea from './TwoWayInputArea.react';

const TwoWayQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customHeader={customHeader}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={TwoWayInputArea}
    />
  );
};

type TwoWayQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const TwoWayQuestion = {
  PreGuess: (props: TwoWayQuestionTypeProps) => (
    <TwoWayQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: TwoWayQuestionTypeProps) => (
    <TwoWayQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {TwoWayQuestion};
